import { useAuthentication } from '~/src/hooks/useAuthentication';

import { DefaultScreenSkeleton } from './DefaultScreenSkeleton';
import { LayoutSkeleton } from './LayoutSkeleton';

type Props = {
  children: React.ReactElement;
};

const RedirectingSkeleton = () => (
  <LayoutSkeleton>
    <DefaultScreenSkeleton />
  </LayoutSkeleton>
);

export const AuthGuard = ({ children }: Props) => {
  const { isAuthenticated, loginWithRedirect } = useAuthentication();

  if (!isAuthenticated) {
    loginWithRedirect({ returnTo: `${location.pathname}${location.search}` });

    return <RedirectingSkeleton />;
  }

  return children;
};
